export default "__VITE_ASSET__CLfiw4SI__"